import { useTranslationsContext } from 'store/translations';
import Arrow from 'assets/img/smooth-arrow-left.svg';
import './CollectionEndOverlayContent.styl';
import { ReactNode, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useResize } from 'src/hooks';
import { sanitize } from 'dompurify';

interface CollectionEndOverlayContentProps {
    navigation: ReactNode;
}

export const CollectionEndOverlayContent = observer(({ navigation }: CollectionEndOverlayContentProps) => {
    const { translate } = useTranslationsContext();
    const { isMob } = useStoreContext();
    const { width } = useResize();
    const [left, setLeft] = useState(isMob ? 329 : 0);

    useLayoutEffect(() => {
        const elem = document.querySelector('.collection-end-overlay-navigation #draw .navigation-item-icon');
        if (elem) {
            setLeft(elem.getBoundingClientRect().left + 5);
        }
    }, [width]);

    return (
        <div className="collection-end-overlay">
            <div className="collection-end-overlay-content" style={{ left: left ? `${left}px` : undefined }}>
                <div
                    className="collection-end-overlay-content-title"
                    dangerouslySetInnerHTML={{ __html: sanitize(translate('collection.end.overlay.text')) }}
                ></div>
                <img className="collection-end-overlay-content-arrow" src={Arrow}></img>
            </div>
            <div className="collection-end-overlay-navigation">{navigation}</div>
        </div>
    );
});
